// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-7f7be272]{color:#c81919}.title--text[data-v-7f7be272]{text-align:center;margin-bottom:12px;font-family:Poppins-Bold,sans-serif;font-size:1.4rem}", ""]);
// Exports
module.exports = exports;
